// extracted by mini-css-extract-plugin
export var banner = "culinary-module--banner--Xtskg";
export var culinary = "culinary-module--culinary--EYy7g";
export var fullWidth = "culinary-module--full-width--MuWjA";
export var icon = "culinary-module--icon--4-YwB";
export var imageContent = "culinary-module--imageContent--hE21n";
export var img = "culinary-module--img--TdMmq";
export var list = "culinary-module--list--vvAH7";